// extracted by mini-css-extract-plugin
module.exports = {"chapters":"SeriesChapters_chapters__43d87"};